import React, { useRef, useState } from "react";
import logo from "../../assets/pics/logoMain.svg";
import chevron_down from "../../assets/pics/chevron_down.svg";
import profile from "../../assets/pics/profile.svg";
import { useNavigate } from "react-router-dom";
import { TieredMenu } from "primereact/tieredmenu";
import { roleBadge } from "../../pages/admin-users/UsersList";

const Navbar = () => {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const adminUser = JSON.parse(localStorage.getItem("adminUser")) || {};

  const [animating, setAnimating] = useState(false);
  const [visible, setVisible] = useState(false);

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  const items = [
    {
      label: "Change Password",
      icon: "pi pi-refresh",
      command: () => navigate("/change-password"),
    },
    { separator: true },
    {
      label: "Logout",
      icon: "pi pi-sign-out",
      command: handleLogout,
      className: "text-red-600",
    },
  ];

  const toggleMenu = (e) => {
    menuRef.current?.toggle(e);
  };

  // Animate with Tailwind via a wrapper state
  const onShow = () => {
    setVisible(true);
    // kick in transition
    requestAnimationFrame(() => setAnimating(true));
  };
  const onHide = () => {
    // run out animation then actually hide
    setAnimating(false);
    setTimeout(() => setVisible(false), 120);
  };

  return (
    <div className="flex justify-between w-full items-center lg:pe-16 lg:ps-6 px-5 py-4 bg-white h-20 fixed left-0 top-0 shadow-md border-b-[0.5px] border-neutral-300 z-50">
      <img src={logo} alt="FMV logo" className="h-8" />

      <div />

      <div className="flex gap-5 items-center">
        <h2 className="lg:text-2xl lg:block hidden font-bold text-primary">FMV Admin Portal</h2>

        <button
          type="button"
          className="flex items-center gap-2 group"
          onClick={toggleMenu}
          aria-haspopup
          aria-expanded={visible}
        >
          <img src={profile} alt="User avatar" className="h-8 w-8 rounded-full ring-1 ring-gray-200" />
          <div className="hidden md:flex flex-col items-start leading-tight">
            <span className="text-sm font-semibold text-gray-900">{adminUser?.name}</span>
            <span className="text-[11px] text-gray-500 pt-1">{roleBadge(adminUser?.role)}</span>
          </div>
          <img
            src={chevron_down}
            alt="Open menu"
            className={`h-5 w-5 transition-transform duration-200 ${
              visible && animating ? "rotate-180" : "rotate-0"
            }`}
          />
        </button>

        {/* PrimeReact popup TieredMenu */}
        <div
          className={`pointer-events-none absolute right-4 top-16 ${
            visible ? "block" : "hidden"
          }`}
        >
          <div
            className={`pointer-events-auto origin-top-right transition-all duration-150 ease-out
              ${animating ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
          >
            <TieredMenu
              ref={menuRef}
              model={items}
              popup
              onShow={onShow}
              onHide={onHide}
              className="rounded-lg shadow-xl ring-1 ring-black/5 overflow-hidden min-w-[230px]"
              popupAlignment="right"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
